import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.loginscreen.AuthenticateModalLit.';

  public static readonly passwordResetSuccess = `${Id.prefix}passwordResetSuccess`;
  public static readonly passwordMismatch = `${Id.prefix}passwordMismatch`;
  public static readonly loginUnsuccessful = `${Id.prefix}loginUnsuccessful`;
  public static readonly passwordUpdateUnsuccessful = `${Id.prefix}passwordUpdateUnsuccessful`;
  public static readonly logIn = `${Id.prefix}logIn`;
  public static readonly enter2FA = `${Id.prefix}enter2FA`;
  public static readonly updatePassword = `${Id.prefix}updatePassword`;
  public static readonly resetPassword = `${Id.prefix}resetPassword`;
  public static readonly password = `${Id.prefix}password`;
  public static readonly enterNewPassword = `${Id.prefix}enterNewPassword`;
  public static readonly userName = `${Id.prefix}userName`;
  public static readonly login = `${Id.prefix}login`;
  public static readonly forgotPassword = `${Id.prefix}forgotPassword`;
  public static readonly authenticationCode = `${Id.prefix}authenticationCode`;
  public static readonly pleaseConfirmPassword = `${Id.prefix}pleaseConfirmPassword`;
  public static readonly close = `${Id.prefix}close`;
  public static readonly verify = `${Id.prefix}verify`;
  public static readonly scanCode = `${Id.prefix}scanCode`;
  public static readonly enterCodeFromApp = `${Id.prefix}enterCodeFromApp`;
  public static readonly twoFAEnabled = `${Id.prefix}twoFAEnabled`;
  public static readonly enable2FA = `${Id.prefix}enable2FA`;
  public static readonly pleaseSignoutPasswordChange = `${Id.prefix}pleaseSignoutPasswordChange`;
  public static readonly accountAlready2FA = `${Id.prefix}accountAlready2FA`;
  public static readonly logout = `${Id.prefix}logout`;
}

export class LangAuthenticateModalLit {
  private constructor() {}
  public static passwordResetSuccess(): string {
    return interpolate(Id.passwordResetSuccess);
  }
  public static passwordMismatch(): string {
    return interpolate(Id.passwordMismatch);
  }
  public static loginUnsuccessful(params: { statusText: string }): string {
    return interpolate(Id.loginUnsuccessful, params);
  }
  public static passwordUpdateUnsuccessful(params: { statusText: string }): string {
    return interpolate(Id.passwordUpdateUnsuccessful, params);
  }
  public static logIn(): string {
    return interpolate(Id.logIn);
  }
  public static enter2FA(): string {
    return interpolate(Id.enter2FA);
  }
  public static updatePassword(): string {
    return interpolate(Id.updatePassword);
  }
  public static resetPassword(): string {
    return interpolate(Id.resetPassword);
  }
  public static password(): string {
    return interpolate(Id.password);
  }
  public static enterNewPassword(): string {
    return interpolate(Id.enterNewPassword);
  }
  public static userName(): string {
    return interpolate(Id.userName);
  }
  public static login(): string {
    return interpolate(Id.login);
  }
  public static forgotPassword(): string {
    return interpolate(Id.forgotPassword);
  }
  public static authenticationCode(): string {
    return interpolate(Id.authenticationCode);
  }
  public static pleaseConfirmPassword(): string {
    return interpolate(Id.pleaseConfirmPassword);
  }
  public static close(): string {
    return interpolate(Id.close);
  }
  public static verify(): string {
    return interpolate(Id.verify);
  }
  public static scanCode(): string {
    return interpolate(Id.scanCode);
  }
  public static enterCodeFromApp(): string {
    return interpolate(Id.enterCodeFromApp);
  }
  public static twoFAEnabled(): string {
    return interpolate(Id.twoFAEnabled);
  }
  public static enable2FA(): string {
    return interpolate(Id.enable2FA);
  }
  public static pleaseSignoutPasswordChange(): string {
    return interpolate(Id.pleaseSignoutPasswordChange);
  }
  public static accountAlready2FA(): string {
    return interpolate(Id.accountAlready2FA);
  }
  public static logout(): string {
    return interpolate(Id.logout);
  }
}

export class AuthenticateModalLitModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.passwordResetSuccess,
      'Your password has been reset. Please check your email',
      'Password reset success message'
    );
    register.add(Id.passwordMismatch, 'Password does not match Confirmation', 'Password mismatch error');
    register.add(Id.loginUnsuccessful, 'Login unsuccessful: {{statusText}}', 'Login unsuccessful error');
    register.add(
      Id.passwordUpdateUnsuccessful,
      'Password Update unsuccessful: {{statusText}}',
      'Password update unsuccessful error'
    );
    register.add(Id.logIn, 'Log In', 'Login dialog title');
    register.add(Id.enter2FA, 'Enter 2FA Credential', '2FA dialog title');
    register.add(Id.updatePassword, 'Update Password', 'Update password dialog title');
    register.add(Id.resetPassword, 'Reset Password', 'Reset password dialog title');
    register.add(Id.password, 'Password', 'Password label');
    register.add(Id.enterNewPassword, 'Enter New Password', 'Enter new password label');
    register.add(Id.userName, `{{glossary 'user'}} Name`, 'User name label');
    register.add(Id.login, 'Login', 'Login button');
    register.add(Id.forgotPassword, 'Forgot my password', 'Forgot password button');
    register.add(Id.authenticationCode, 'Authentication Code', 'Authentication code label');
    register.add(Id.pleaseConfirmPassword, 'Please confirm password to continue', '2FA password confirmation header');
    register.add(Id.close, 'Close', 'Close button');
    register.add(Id.verify, 'Verify', 'Verify button');
    register.add(Id.scanCode, 'Scan code into authentication app', '2FA scan code header');
    register.add(Id.enterCodeFromApp, 'Enter Code From App', '2FA enter code from app label');
    register.add(Id.twoFAEnabled, '2FA is now enabled', '2FA enabled message');
    register.add(Id.enable2FA, 'Enable 2FA', 'Enable 2FA dialog title');
    register.add(
      Id.pleaseSignoutPasswordChange,
      'Please signout and login again, as a password change is required',
      '2FA password change required message'
    );
    register.add(Id.accountAlready2FA, 'This account is already using 2FA', '2FA already enabled message');
    register.add(Id.logout, 'Logout', 'Logout button');
  }
}
